import { Text } from "@nju/ui";

interface IRowProps {
  testId?: string;
  title: string;
  value: string;
}

export function Row({ testId, title, value }: IRowProps) {
  return (
    <div className="flex justify-between w-full" data-cy={testId}>
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
      >
        {title}
      </Text>
      <Text
        className="whitespace-nowrap"
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
        weight="bold"
      >
        {value}
      </Text>
    </div>
  );
}
